import React from 'react';
import { Field, ErrorMessage } from 'formik';

import { Icon } from '@iconify/react/dist/iconify.js';
import DepartmentCheckboxGroup from '../departments/DepartmentCheckboxGroup';

const Step5 = () => (
    <div style={{ width: '100%', maxWidth: '400px' }}>
        <p style={{ fontStyle: 'italic', textAlign: 'justify' }}>Great! You've reached the final step! Now the fun part! Tell us a bit about your mobility and ESN experience (if you did more than one, just tell us about your favourite one)</p>

        <div className={"main-descriptions user-title"} style={{ width: '100%', marginTop: '20px' }}>
            Mobility and ESN Experience
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label htmlFor="mobilityPlace">I did my Mobility in <i>(Optional)</i></label>
            <Field name="mobilityPlace" placeholder="Zagreb" className='login-input' style={{ marginTop: '5px' }} />
            <ErrorMessage name="mobilityPlace" component="div" style={{ color: '#CD3E3D' }} />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
            <label htmlFor="mobilityProgram">Mobility Program <i>(Optional)</i></label>
            <Field name="mobilityProgram" placeholder="Erasmus+" className='login-input' style={{ marginTop: '5px' }} />
            <ErrorMessage name="mobilityProgram" component="div" style={{ color: '#CD3E3D' }} />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
            <label htmlFor="dateJoined">Date I joined ESN</label>
            <Field name="dateJoined" type='date' placeholder="123456789" className='login-input' style={{ marginTop: '5px' }} />
            <ErrorMessage name="dateJoined" component="div" style={{ color: '#CD3E3D' }} />
        </div>

        {/* -------------- Membership: Newbie, Intern -------------- */}
        <div style={{ marginTop: '20px' }}>
            <p className='radio-description'>I'm a ... member</p>
            <div className='radio-container'>
                <div className="radio-select">
                    <Field type="radio" id="newbie" name="membershipType" value="Newbie" />
                    <label htmlFor="newbie">
                        <Icon icon="material-symbols:circle-outline" width="1.5rem" height="1.5rem" className='radio-icon radio-empty' />
                        <Icon icon="material-symbols:circle" width="1.5rem" height="1.5rem" className='radio-icon radio-full' />
                        Newbie</label>
                </div>

                <div className="radio-select">
                    <Field type="radio" id="intern" name="membershipType" value="Intern" />
                    <label htmlFor="intern">
                        <Icon icon="material-symbols:circle-outline" width="1.5rem" height="1.5rem" className='radio-icon radio-empty' />
                        <Icon icon="material-symbols:circle" width="1.5rem" height="1.5rem" className='radio-icon radio-full' />
                        Intern </label>
                </div>

            </div>

        </div>

        {/* -------------- Departments -------------- */}
        <div style={{ marginTop: '20px' }}>
            <p className='radio-description'>My department is:</p>
            <DepartmentCheckboxGroup maxSelections={1} />
        </div>

    </div>
);

export default Step5;
